import React, { useState } from 'react';

import PropTypes from 'prop-types';
import { Spinner } from '@telus-uds/components-web';

import {
  ApproveButton,
  ButtonWrapper,
  DeclineButton,
  EditOverlay,
  PendingApprovalLabel
} from '../../css';

import request from '../../../utils/request';

const Overlay = ({ id, fetchData, setInDeleteMode }) => {
  const [isDeleting, setIsDeleting] = useState(false);

  const resetState = () => {
    setIsDeleting(false);
    setInDeleteMode(false);
    fetchData();
  };

  const handleDelete = async () => {
    setIsDeleting(true);
    try {
      const result = await request.post(`/users/${id}/delete`);

      if (result) resetState();
    } catch (err) {
      resetState();
      throw err;
    }
  };

  return (
    <EditOverlay>
      <Spinner label="Deleting..." show={isDeleting}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '1rem',
            width: '100%',
            alignItems: 'center'
          }}
        >
          <PendingApprovalLabel center>
            Are you sure you want to delete users profile?
          </PendingApprovalLabel>
          <ButtonWrapper center>
            <ApproveButton onClick={handleDelete}>Confirm</ApproveButton>
            <DeclineButton onClick={() => setInDeleteMode(false)}>
              Cancel
            </DeclineButton>
          </ButtonWrapper>
        </div>
      </Spinner>
    </EditOverlay>
  );
};

Overlay.propTypes = {
  id: PropTypes.number.isRequired,
  fetchData: PropTypes.func.isRequired,
  setInDeleteMode: PropTypes.func.isRequired
};

export default Overlay;
